import React from 'react';

import './style.sass';

import parse from 'html-react-parser';
import ScrollAnimation from '../../../../../../../../core/ScrollAnimation';

const ParametersInfo = () => {
    let list = [
        'alfabank.ru/sme/raschetnyj-schet/ip/docs/',
        'alfabank.ru/sme/raschetnyj-schet/yur-lico/',
        'alfabank.ru/sme/raschetnyj-schet/ooo/',
        'www.sberbank.ru/ru/s_m_business/bankingservice/raschyotnyj-schyot-dlya-yuridicheskih-lic',
        'www.sberbank.ru/ru/s_m_business/bankingservice/raschyotnyj-schyot-dlya-ooo ',
    ];

    return (
        <div className="parameters-info">
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                <ScrollAnimation
                    animateIn="fadeInUp"
                    offset={100}
                    animateOnce={true}
                    duration={1}
                    className="upgreat-tasks__content"
                >
                    <div className="parameters-info__content">
                        <div className="parameters-info__block-text">
                            <div className="parameters-info__text">
                                По данным таблицы делаем выводы, сайты с какими параметрами лучше
                                ранжируются. Например, у Сбербанка, Альфа-Банка, Тинькоффа расширена
                                семантика + созданы и оптимизированы страницы под разные группы
                                запросов, что в свою очередь может улучшать их позиции по нескольким
                                группам, например:
                            </div>
                            <div className="parameters-info__list">
                                <ul className={`common__circle-list`}>
                                    {list.map((item, index) => {
                                        return (
                                            <li className={`common__circle-item`} key={index}>
                                                <span className={`common__circle-number`} />
                                                <a
                                                    href={`https://${parse(item)}`}
                                                    className={'common__circle-info'}
                                                    target="_blank"
                                                    rel="noopener noreferrer nofollow"
                                                >
                                                    {parse(item)}
                                                </a>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                            <div className="parameters-info__text">
                                Эти конкуренты ранжируются большим количеством запросов, что в свою
                                очередь хорошо отражается на ранжировании сайтов в ПС. Отметим, что
                                в целом количество страниц этих сайтов в ПС значительно больше. А
                                вот региональные страницы, например, были обнаружены только
                                Альфа-банка и ВТБ.
                            </div>
                            <div className="parameters-info__text">
                                Из 6 банков можно выделить три основных - это Сбербанк, Альфа-банк и
                                ВТБ. У данных сайтов присутствуют оптимизированные текстовые блоки,
                                достаточно хороший ссылочный вес, хорошо расширена семантика, у
                                некоторых есть региональные страницы.
                            </div>
                            <div className="parameters-info__text">
                                По данным аудита и анализа конкурентов мы составляем список
                                доработок, которые надо исправить, и выделяем несколько точек роста
                                сайта банка для улучшения ранжирования в ПС.
                            </div>
                        </div>

                        <div className="parameters-info__block-right">
                            <div className="parameters-info__block-img">
                                <img
                                    className="parameters-info__img"
                                    src="/images/pic/seo-fintech/parameteres.png"
                                    alt=""
                                    loading="lazy"
                                />
                            </div>
                            <a
                                href="https://alfabank.ru/sme/raschetnyj-schet/ip/docs/"
                                target="_blank"
                                rel="noopener noreferrer nofollow"
                            >
                                alfabank.ru/sme/raschetnyj-schet/ip/docs/
                            </a>
                        </div>
                    </div>
                </ScrollAnimation>
            </ScrollAnimation>
        </div>
    );
};

export default ParametersInfo;
